import { ModuleData } from '../../Types/containerV2';
import { isButtonModuleContent } from '../../Types/containerV2/modules/button';
import ModuleActionSurface from './ModuleActionSurface';
import './ButtonModule.scss';
import { useContainerContext } from './ContainerContext';

type ButtonModuleProps = {
	module: ModuleData;
};

const ButtonModule = ({ module }: ButtonModuleProps) => {
	const { isValueSelected, isActionDisabled } = useContainerContext();
	if (!isButtonModuleContent(module.content)) {
		return null;
	}

	const selected = module.onClick?.type === 'select-value' && isValueSelected(module.onClick.group, module.onClick.value);
	return (
		<ModuleActionSurface
			className='biz-button-module'
			label={module.content.buttonText || 'Button'}
			disabled={module.onClick ? isActionDisabled(module.onClick) : false}
			trailingIcon={selected ? <span aria-hidden='true'>✓</span> : undefined}
		/>
	);
};

export default ButtonModule;
